import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@material-ui/core';
import { stringToColor, getInitials } from 'ui-utils';
import { muiThemeLuma } from 'themes';

class PatientAvatar extends PureComponent {
  renderStatusIcon() {
    const { item } = this.props;
    const style = {
      borderRadius: '50%',
      bottom: 0,
      display: 'inline-block',
      height: '30%',
      position: 'absolute',
      right: 0,
      width: '30%',
    };

    if (!('isOnline' in item)) return;

    style.backgroundColor = item.isOnline ? muiThemeLuma.custom.palette.colorSuccess : '#5f5f5f';

    return <div style={style} />;
  }

  render() {
    const { classes, item, style, ...props } = this.props;

    if (!item || !item.name) return null;

    const initials = getInitials(item.name);
    const backgroundColor = stringToColor(initials);

    return (
      <Avatar style={{ backgroundColor, position: 'relative', ...style }} {...props}>
        {initials}
        {this.renderStatusIcon()}
      </Avatar>
    );
  }
}

PatientAvatar.propTypes = {
  item: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  style: PropTypes.object,
};

export default PatientAvatar;
